import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {COMMON_DIALOG_IMPORTS} from "../../../../shared/import-groups/Common";
import {GenerateTableParseResponse, GenerateTableParseResponseDialog} from "../../../../_models/parser-config-template";


@Component({
    selector: 'src-generate-table-parse-response-dialog',
    templateUrl: './generate-table-parse-response-dialog.component.html',
    styleUrls: ['./generate-table-parse-response-dialog.component.less'],
    encapsulation: ViewEncapsulation.None,
    imports: [
    COMMON_DIALOG_IMPORTS
],
    // Global Styles
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenerateTableParseResponseDialogComponent implements OnInit {

    parse_response: GenerateTableParseResponse;

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        public dialogRef: MatDialogRef<GenerateTableParseResponseDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: GenerateTableParseResponseDialog) {
        this.parse_response = data.parse_response;
    }

    ngOnInit(): void {
        this.changeDetectorRef.markForCheck();
    }

    closeDialog(): void {
        this.dialogRef.close();
    }
}
